import { Component, OnInit, OnDestroy } from '@angular/core';
import { DbService } from "../../services/db/db.service";

@Component({
  selector: 'app-downloads',
  imports: [],
  templateUrl: './downloads.component.html',
  styleUrl: './downloads.component.scss'
})
export class DownloadsComponent implements OnInit, OnDestroy{

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  constructor(private db: DbService) { }

  androidDownloaded(): void {
    console.log("Android Download Clicked");
    this.db.updateAndroidDownload({count : 1}).subscribe((result) => {
      console.log(result);
    });
  }

  iosDownloaded(): void {
    console.log("iOS Download Clicked");
    this.db.updateiOSDownload({count : 1}).subscribe((result) => {
      console.log(result);
    });
  }

  winDownloaded(): void {
    console.log("Windows Download Clicked");
    this.db.updateWinDownload({count : 1}).subscribe((result) => {
      console.log(result);
    });
  }

  macDownloaded(): void {
    console.log("Mac Download Clicked");
    this.db.updateMacDownload({count : 1}).subscribe((result) => {
      console.log(result);
    });
  }
}
